import React, { useEffect } from "react";
import "../style/components/Footer.css";
import Inactive from "../assets/images/Inactive.svg";
import { useLocation } from "react-router-dom";
import { clearSession } from "../utils/auth";
import { secondsToTime } from "../utils/time";
import { useIdle } from "../hooks/use-idle";
import { useCountdown } from "../hooks/use-countdown";
import { useDocumentTitle } from "../hooks/use-document-title";

const InactiveConfig = {
  idleTimeoutSecond: 60 * 10, // 10 minutes
  idleWarningSecond: 60 * 8, // 8 minutes
  otp: {
    idleTimeoutSecond: 60 * 14, // 14 minutes
    idleWarningSecond: 60 * 12, // 12 minutes
  },
};

export type SessionInactiveBroadcast = {
  kind: "session:remove:inactive:tabs";
};

const InactiveAlertModal = () => {
  const location = useLocation();
  const resendCode = location.pathname.includes("/signup/verificationcode");
  const resetPassword = location.pathname.includes("/reset/verificationcode");
  const loginResendCode = location.pathname.includes("/login/verificationcode");

  if (resendCode || resetPassword || loginResendCode) {
    InactiveConfig.idleTimeoutSecond = InactiveConfig.otp.idleTimeoutSecond; // 14 minutes
    InactiveConfig.idleWarningSecond = InactiveConfig.otp.idleWarningSecond; // 12 minutes
  }

  const offset =
    InactiveConfig.idleTimeoutSecond - InactiveConfig.idleWarningSecond;

  const setTitle = useDocumentTitle("MSI UK");
  const isIdle = useIdle(InactiveConfig.idleWarningSecond * 1000);
  const { count, start, clear } = useCountdown({
    seconds: offset,
    onExpire: () => {
      _clearSession();
    },
  });

  const [timer, setTimer] = React.useState("");
  useEffect(() => {
    if (isIdle) {
      start();
      setTimer(secondsToTime(offset));
    } else {
      clear();
      setTimer(secondsToTime(0));
    }
  }, [isIdle]);

  useEffect(() => {
    if (count > 0 && isIdle) {
      const offsetTime = count;
      setTimer(secondsToTime(offsetTime));
      setTitle(secondsToTime(offsetTime) + "- Inactive");
    } else {
      setTitle("MSI UK");
    }
  }, [count, isIdle]);

  const _clearSession = () => {
    clearSession("InactiveAlert");
  };

  return (
    <>
      {isIdle && (
        <>
          <div className="alertoverlay"></div>
          <div className="alertpopup">
            <div className="alert-container">
              <div className="alertside">
                <div className="alerticon">
                  <img src={Inactive} alt="Inactive Icon" />
                </div>
                <div className="alerttext">
                  This browser window will be closed after 2 minutes of
                  inactivity - {timer} remaining
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

const InactiveAlert = () => {
  return <>{<InactiveAlertModal />}</>;
};

export default InactiveAlert;
